
















































































































































































import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DeductiblePaymentSelect from '@/components/DeductiblePaymentSelect.vue';
import DeductibleTypeSelect from '@/components/DeductibleTypeSelect.vue';
import MappingPropertyInput from '@/components/Importer/MappingPropertyInput.vue';
import QuotaTimeSelect from '@/components/QuotaTimeSelect.vue';
import TransportationPermission from '@/components/Passenger/models/TransportationPermission';
import TripDestinationsSelect from '@/components/TripDestinationsSelect.vue';
import TripDirectionsSelect from '@/components/TripDirectionsSelect.vue';

@Component({
  components: {
    DeductiblePaymentSelect,
    DeductibleTypeSelect,
    MappingPropertyInput,
    QuotaTimeSelect,
    TripDestinationsSelect,
    TripDirectionsSelect,
  },
})
export default class TransportationPermissionMapper extends Vue {
  mapping: IEntityMapping<TransportationPermission> | null = null;

  @Prop({ required: true }) value: IEntityMapping<TransportationPermission>;
  @Prop({ required: true }) index: number;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mapping = this.value;
  }

  @Watch('mapping', { deep: true, immediate: true }) onMappingChanged() {
    this.$emit('input', this.mapping);
  }

  removeMapping() {
    this.$emit('delete');
  }

}
